import createIcon from '../../createIcon';

/**
 * @component @name AccessAlarm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNS43ODk2OUwxNy40IDEuOTI5NjlMMTYuMTEgMy40NTk2OUwyMC43MSA3LjMxOTY5TDIyIDUuNzg5NjlaTTcuODggMy40NTk2OUw2LjYgMS45Mjk2OUwyIDUuNzc5NjlMMy4yOSA3LjMwOTY5TDcuODggMy40NTk2OVpNMTIuNSA4LjA2OTY5SDExVjE0LjA2OTdMMTUuNzUgMTYuOTE5N0wxNi41IDE1LjY4OTdMMTIuNSAxMy4zMTk3VjguMDY5NjlaTTEyIDQuMDY5NjlDNy4wMyA0LjA2OTY5IDMgOC4wOTk2OSAzIDEzLjA2OTdDMyAxOC4wMzk3IDcuMDIgMjIuMDY5NyAxMiAyMi4wNjk3QzE2Ljk3IDIyLjA2OTcgMjEgMTguMDM5NyAyMSAxMy4wNjk3QzIxIDguMDk5NjkgMTYuOTcgNC4wNjk2OSAxMiA0LjA2OTY5Wk0xMiAyMC4wNjk3QzguMTMgMjAuMDY5NyA1IDE2LjkzOTcgNSAxMy4wNjk3QzUgOS4xOTk2OSA4LjEzIDYuMDY5NjkgMTIgNi4wNjk2OUMxNS44NyA2LjA2OTY5IDE5IDkuMTk5NjkgMTkgMTMuMDY5N0MxOSAxNi45Mzk3IDE1Ljg3IDIwLjA2OTcgMTIgMjAuMDY5N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccessAlarm = createIcon('AccessAlarm', [
  [
    'path',
    {
      d: 'M22 5.78969L17.4 1.92969L16.11 3.45969L20.71 7.31969L22 5.78969ZM7.88 3.45969L6.6 1.92969L2 5.77969L3.29 7.30969L7.88 3.45969ZM12.5 8.06969H11V14.0697L15.75 16.9197L16.5 15.6897L12.5 13.3197V8.06969ZM12 4.06969C7.03 4.06969 3 8.09969 3 13.0697C3 18.0397 7.02 22.0697 12 22.0697C16.97 22.0697 21 18.0397 21 13.0697C21 8.09969 16.97 4.06969 12 4.06969ZM12 20.0697C8.13 20.0697 5 16.9397 5 13.0697C5 9.19969 8.13 6.06969 12 6.06969C15.87 6.06969 19 9.19969 19 13.0697C19 16.9397 15.87 20.0697 12 20.0697Z',
      key: 'hwzn1w',
    },
  ],
]);

export default AccessAlarm;
